import React from 'react';
import { Outlet } from 'react-router-dom';
import { SBack } from '@/components/ui/molecules/SBack';
import { SFooterNav, NavItem } from '@/components/ui/organisms/SFooterNav';
import './BookingLayout.css';

interface BookingLayoutProps {
  children?: React.ReactNode;
  onBackClick?: () => void;
  backLabel?: string;
  headerRightSlot?: React.ReactNode;
  centerHeader?: boolean;
  showHeader?: boolean;
  showFooter?: boolean;
  activeNav?: NavItem;
  onNavClick?: (item: NavItem) => void;
}

const BookingLayout: React.FC<BookingLayoutProps> = ({
  children,
  onBackClick,
  headerRightSlot,
  centerHeader = false,
  showHeader = true,
  showFooter = true,
  activeNav = 'home',
  onNavClick,
}) => {
  return (
    <div className="booking-layout-container">
      {/* Sticky Header with SBack */}
      {showHeader && <div className="booking-layout-header">
        <div className="booking-layout-back">
          <SBack onClick={onBackClick} />
        </div>
        {headerRightSlot && (
          centerHeader ? (
            <div className="booking-layout-header-center">
              {headerRightSlot}
            </div>
          ) : (
            <div className="booking-layout-header-right">
              {headerRightSlot}
            </div>
          )
        )}
        {centerHeader && headerRightSlot && (
          <div className="booking-layout-spacer"></div>
        )}
      </div>}

      {/* Main Content Area */}
      <main className="booking-layout-main">
        {children || <Outlet />}
      </main>
      
      {/* Footer Navigation */}
      {showFooter && (
        <div className="booking-layout-footer">
          <SFooterNav activeItem={activeNav} onItemClick={onNavClick} />
        </div>
      )}
    </div>
  );
};

export default BookingLayout;
